import React from 'react'

type Props = {
  links: Array<{
    name: string
    href: string
  }>
}

function SectionLinks({ links }: Props) {
  return (
    <nav className="flex gap-x-4 gap-y-1 flex-wrap" aria-label="Section links">
      {links.map((tab) => (
        <a
          key={tab.name}
          href={tab.href}
          className="text-gray-500 hover:text-gray-700 px-4 py-2 font-medium text-sm rounded-md"
        >
          {tab.name}
        </a>
      ))}
    </nav>
  )
}

export default SectionLinks